// extracted by mini-css-extract-plugin
export default {"default":"IsaacList_default__VlIYG"};